import i18n from '@/i18n'
import BlankLayout from '../../layout/blankLayout.vue'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import Index from './index.vue'

const basePath = '/v-admin/automation-setting/management'

export default {
  name: 'automationSettings',
  path: `${basePath}`,
  component: BlankLayout,
  redirect: `${basePath}/index`,
  meta: {
    isInclude: true,
    titleI18nKey: 'admin.job.editor.title.automationSettingsTitle',
    menu: {
      get label () {
        return i18n.t('admin.job.editor.title.automationSettingsTitle')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    },
    isNewPage: true
  },
  children: [
    {
      name: 'automationSettingsIndex',
      component: Index,
      path: `${basePath}/index`,
      meta: {
        isInclude: true,
        titleI18nKey: 'admin.job.editor.title.automationSettingsTitle',
        menu: {
          get label () {
            return i18n.t('admin.job.editor.title.automationSettingsTitle')
          },
          group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
        },
        isNewPage: true
      }
    }
  ]
}
